import { EBrand, EHostLang } from 'affiny-core/types/env.types';
import { overrideConfig, sharedConfigKubePreprod } from './shared-config';

export const getKubePreprodConfig = (brand: EBrand, hostLang: EHostLang) => {
  return {
    credentials: {
      sentryDSN: 'https://bf5a7fff3ef341a891d466297254b4a4@sentry.io/1405886',
      algoliaApiKey: '831506aac16971f9aa4651be9b69c814',
      algoliaAppId: 'plYG601EXJGU',
    },
    ...sharedConfigKubePreprod,
    ...overrideConfig(brand, hostLang),
  };
};
